<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content [innerHTML]="data.message" class="mb-3"></mat-dialog-content> <!-- mat-dialog-content -->

<div *ngIf="chekboxShowAgain">
  <mat-checkbox class="checkbox-insert" (change)="onShowAgain($event.checked)"
    color="primary">
    <strong>{{ 'dialogs.confirm.dontShowAgain' | translate }}</strong>
  </mat-checkbox>
</div>


<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-raised-button [color]="data.btnCancelColor" (click)="onDenial()" *ngIf="showBnt">
      <mat-icon fontSet="fal" [fontIcon]="data.btnCancelIcon"></mat-icon>
      {{ data.btnCancelText }}
    </a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
  </div> <!-- /.col -->
</div> <!-- /.row -->